import JSZip from "jszip"; // Use JSZip for zipping files
import { saveAs } from "file-saver"; // FileSaver.js for saving files

const downloadMultiPDF = async (files, nompiece, nom) => {
  const urls = files.map((file) => file.url);
  const names = files.map((file) => file.name);

  const pdfList = urls.map((url, index) => ({
    storage_path: url,
    file_name: names[index],
  }));

  const zip = new JSZip();

  try {
    // Fetch each file and add it to the zip
    for (const pdfInfo of pdfList) {
      if (pdfInfo.storage_path) {
        const response = await fetch(pdfInfo.storage_path); // Fetch from the provided URL
        if (response.ok) {
          const pdfData = await response.arrayBuffer(); // Get the file data as an ArrayBuffer
          zip.file(pdfInfo.file_name, pdfData); // Add the file to the zip
        } else {
          console.error(`Failed to fetch file: ${pdfInfo.storage_path}`);
        }
      }
    }

    // Generate the zip file
    const zipBlob = await zip.generateAsync({ type: "blob" });

    // Save the zip file using FileSaver.js
    saveAs(zipBlob, `${nompiece}_${nom}.zip`);
  } catch (error) {
    console.error(`Error in downloading and zipping files: ${error.message}`);
  }
};

export default downloadMultiPDF;
